import { getInstance } from '@module-federation/enhanced/runtime';
import { getManifestUrl, getRemoteAppRoutesMapFromGraniteOptions } from './utils';
import { findMostSpecificRoute } from 'quartz-routing/internal/routeMatchingUtils';
function LinkPlugin() {
  return {
    name: 'link-plugin',
    createLink({
      url
    }) {
      const link = document.createElement('link');
      link.setAttribute('href', url);
      link.setAttribute('rel', 'preload');
      link.setAttribute('as', 'script');
      link.setAttribute('crossorigin', 'anonymous');
      return link;
    }
  };
}
let isSetup = false;
export function setup() {
  if (isSetup) return;
  const instance = getInstance();
  instance === null || instance === void 0 || instance.registerPlugins([LinkPlugin()]);
  isSetup = true;
}
function getInitialRemote() {
  const routesToRemotesMap = getRemoteAppRoutesMapFromGraniteOptions();
  if (!routesToRemotesMap) {
    throw new Error('Missing remote routes! Granite host apps must be configured with valid remote routes.');
  }
  const mostSpecificMatch = findMostSpecificRoute(Object.keys(routesToRemotesMap), window.location.pathname);
  if (!mostSpecificMatch) {
    throw new Error(`No remote found for current route: ${window.location.pathname}`);
  }
  return routesToRemotesMap[mostSpecificMatch];
}
export function preloadInitialRemote() {
  let remote;
  try {
    remote = getInitialRemote();
  } catch (error) {
    console.error(error);
    return;
  }
  const instance = getInstance();
  if (!instance) {
    console.error('Module federation instance not found in preloadInitialRemote');
    return;
  }
  if (!remote) {
    return;
  }
  instance.registerRemotes([{
    name: remote,
    entry: getManifestUrl(remote)
  }]);
  instance.preloadRemote([{
    nameOrAlias: remote,
    exposes: ['.', 'lang', 'load-dlbs']
  }]).catch(error => {
    console.error(`Failed to preload initial remote "${remote}": ${error}`);
  });
  instance.loadRemote(`${remote}/early`).then(__mod => {
    // do nothing with the imported module, its side effects will do the work
  }).catch(e => {
    console.error(`Error in federated early entry for remote ${remote}. Original error: ${e}`);
  });
}